import axios from 'axios';

import {getBaseUrl} from '@shared/lib/helpers/common';


/**
 * AXIOS client instance
 *
 * @type       {object}
 */
const AxiosInstance = axios.create({
  // baseURL: API_END_POINTS.BASE_URL+AsyncStorage.getItem('test'),
  withCredentials: true
});

AxiosInstance.CancelToken = axios.CancelToken;
AxiosInstance.isCancel = axios.isCancel;

AxiosInstance.defaults.timeout = 10000000;
AxiosInstance.defaults.headers.common['Content-Type'] = 'application/json';
AxiosInstance.getSportsbookUrl = getBaseUrl();

/**
 * Cancellable interfaces
 *
 * This interface the request cancellable token module
 * - @shared/services/main/request/tokens
 */
AxiosInstance.createCancelToken = function () {
  let source = AxiosInstance.CancelToken.source();
  //  overcome AXIOS ISSUES it merges the cancel token incorrectly, so we trick it and move it from the prototype to the object itself
  source.throwIfRequested = source.token.throwIfRequested;
  source.promise = source.token.promise;
  // source.promise.then = source.token.promise.then.bind(source.token.promise);
  // source.promise.catch = source.token.promise.catch.bind(source.token.promise);
  return source;
};

AxiosInstance.getCancelToken = function(token_key) {
  return this.cancel_tokens[token_key] || null;
};

AxiosInstance.cancelToken = function (token_key) {
  var source = this.getCancelToken(token_key);
  source.cancel();
};


export default AxiosInstance;